import { Box,Button,Flex,Select,InputGroup,
  InputLeftElement,Input, Text, 
  TableContainer,Table,Thead,Tbody,Th,Tr,Td,Grid,GridItem } from "@chakra-ui/react";
import { TopDisplay } from "../../../../components";
import { IoMdAdd as AddIcon } from "react-icons/io";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useState , useEffect} from "react";
import { useMutation, useQuery, useQueryClient } from 'react-query';
import styled from "@emotion/styled";
import { atom, useAtom } from 'jotai';
import apiCall from '../../../../utils/apiCall';
import {TopLink} from '../';
import {openAtom,modalAtom,openNAtom,notificationAtom} from '../../../../context';
import { Formik,Form,Field } from "formik";
import {TablePopUp} from '../../../../components';
import * as Yup from 'yup';
import { format } from "date-fns";
import { Loader } from "../../../../customs";
import { TbReload as ReloadIcon } from "react-icons/tb";
import ReactPaginate from 'react-paginate';


// const allSuspend = [
//   {
//     Id:Math.floor(Math.random() * 10000)+1,
//     ExamId:'12345',
//     SubjectName:'Internet of things',
//     Level:'2',
//     CutOffMark: '50',
//     Amount:'300,000'
//   },
//   {
//     Id:Math.floor(Math.random() * 10000)+1,
//     ExamId:'12345',
//     SubjectName:'Internet of things',
//     Level:'2',
//     CutOffMark: '50',
//     Amount:'300,000'
//   },
//   {
//     Id:Math.floor(Math.random() * 10000)+1,
//     ExamId:'12345',
//     SubjectName:'Internet of things',
//     Level:'2',
//     CutOffMark: '50',
//     Amount:'300,000'
//   } ,
//   {
//     Id:Math.floor(Math.random() * 10000)+1,
//     ExamId:'12345',
//     SubjectName:'Internet of things',
//     Level:'2',
//     CutOffMark: '50',
//     Amount:'300,000'
//   },
//   {
//     Id:Math.floor(Math.random() * 10000)+1,
//     ExamId:'12345',
//     SubjectName:'Internet of things',
//     Level:'2',
//     CutOffMark: '50',
//     Amount:'300,000'
//   }  
// ]

const HeadStyle={
  borderBottom:"1px solid var(--dark-green-color)",
  padding:'15px 5px',
}
const DataStyle = {
  padding:'5px 5px',
}


const ROWSTYLE = styled.tr`
  & > td:last-of-type > *{
    display:none;
  }
  :hover > td{
    background-color:var(--table-highlight);
    &:last-of-type > *{
      display:block;
    }
  } 
  &.active > td:last-of-type > *{
    display:block !important;
  }  
`

const SuspendAtom = atom<number | null>(null);


export default function ResetUser() {
  const [hide,set_hide] = useState<boolean>(true);
  const [,set_modal] = useAtom(modalAtom);
  const [,set_open] = useAtom(openAtom);
  const [active] = useAtom<number | string | null>(SuspendAtom);

  const {data:all_student,isLoading} = useQuery(['student-reset'],{
    queryFn:async()=>await apiCall().get(`/Exam/GetStudentsforReset?PageNumber=1&PageSize=100`),
    select(data){
     // console.log(data,'studentdueforreset')
    return data.data.students;
    }
  });
  const [search,set_search] = useState('');
  const [filter_data,set_filter_data] = useState<any>(all_student);

  const handleAddReset = () =>{
    set_modal({
      header:'Reset Student Password',
      content:<AddType />
    })
    set_open(true);
}
const handleSearch = (e:any)=>{
  let val = e.target.value;
  set_search(val);
  if(val){
    let new_data = filter_data?.filter((eData:any) => Object.values(eData).join('').toLowerCase().includes(val.toLowerCase()) );
    if(new_data.length > 0)set_filter_data(new_data)
    else set_filter_data(all_student)
  }
  else set_filter_data(all_student)
}

const itemsPerPage = 10;
const [itemOffset, setItemOffset] = useState(0);
const endOffset = itemOffset + itemsPerPage;
console.log(`Loading items from ${itemOffset} to ${endOffset}`);
const currentItems = filter_data?.slice(itemOffset, endOffset);
const pageCount = Math.ceil(filter_data?.length / itemsPerPage);

const handlePageClick = (event:any) => {
  const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
  console.log(
    `User requested page number ${event.selected}, which is offset ${newOffset}`
  );
  setItemOffset(newOffset);
};
useEffect(()=>{
  set_filter_data(all_student)
},[all_student])

  return (
    <> 
    {isLoading?<Loader />:
    <Box>
      <TopLink />
      <TopDisplay label="Reset Student Password" button_array={[
          <Button onClick={handleAddReset} bg="var(--dark-green-color)" color="var(--white-color)"  type="button"  leftIcon={<AddIcon/>}>Reset Student Password</Button>
        ]} />
        <Flex  gap="20px" wrap="wrap" mt="20px">
          <InputGroup width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
            <InputLeftElement pointerEvents='none'>
              <SearchIcon color='gray.300' />
            </InputLeftElement>
            <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
          <span style={{position:'absolute',zIndex:'1',
          right:'10px',cursor:'pointer',top:'12px'}}><ReloadIcon /></span>
          </InputGroup>
          {/* <Select placeholder="Status" width="150px" bg="var(--white-color)" 
            borderColor="var(dark-green-color)">
               {allStatus && allstatus.length  > 0?
               allstatus.map((eCountry:any) =>
                <option key={pending}>{eCountry.CountryName}</option>
               )
              :'' } 
          </Select> */}

        </Flex>
        <Flex mt="25px" flexDir="column" gap="10px">
        <Text m="0" fontSize="1rem">All Students</Text>
          <Text m="0" fontSize=".8rem">Showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
        </Flex>
     { filter_data && filter_data.length > 0 ? <TableContainer mt="20px">
          <Table size='sm'>
            <Thead>
              <Tr >
                <Th sx={HeadStyle}>Student ID</Th>
                <Th sx={HeadStyle}>First Name</Th>
                <Th sx={HeadStyle}>Last Name</Th>
                <Th sx={HeadStyle}>Email</Th>
                <Th sx={HeadStyle}>Reset Date</Th>
                <Th sx={HeadStyle} w="50px"></Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentItems.map((eStudent:any,index:number) =><ROWSTYLE key={index} className={index === active?'active':''}>
                <Td sx={DataStyle}>{eStudent.StudentNo || 'N/A'}</Td>
                <Td sx={DataStyle}>{eStudent.FirstName}</Td>
                <Td sx={DataStyle}>{eStudent.LastName}</Td>
                <Td sx={DataStyle}>{eStudent.Email}</Td>
                <Td sx={DataStyle}>{format(new Date(eStudent.LastModified), "dd/MM/yyyy")}</Td>
                <Td sx={DataStyle} w="50px" h="50px">
                  <TempPopUp index={index} data={eStudent}/>
                </Td>
              </ROWSTYLE>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        :' Sorry No  student'  
      }
      <StylePaginateBox>
      <ReactPaginate
        breakLabel="..."
        nextLabel=">"
        onPageChange={handlePageClick}
        pageRangeDisplayed={5}
        pageCount={pageCount}
        previousLabel="<"
        renderOnZeroPageCount={null}
      />

    </StylePaginateBox>

    </Box>
}
    </>
   
  )
}
const StylePaginateBox = styled.div`
width:100%;
& > ul{
  list-style-type: none;
  text-align:center;
  padding:0;
  margin:0;
  margin-top:10px;
} 
& > ul > li{
  display: inline;
  margin:0 5px;
  padding:2px 5px;
  border-radius: 3px;
  background-color: transparent;
  color:var(--dark-green-color);
}
& > ul > li.selected{
  background-color: var(--highlight-paginate-background);
  color:var(--highlight-paginate-color);
}
& > ul > li:first-of-type,
& > ul > li:last-of-type{
  font-weight: bold;
}
`

const AddSchema = Yup.object({
  StudentNo:Yup.string().required(),
  Password:Yup.string().required(),

 
});

const AddType = (props:any) =>{
  const queryClient = useQueryClient();
  const [,set_open] = useAtom(openAtom);
  const [,set_Nopen] = useAtom(openNAtom);
  const [,set_notification]= useAtom(notificationAtom);

  const { mutate: addUpdate, isLoading } = useMutation({
    mutationKey: ['new-reset-password'],
    mutationFn: async (data: any) => {
      // Send data as JSON in the body
      return await apiCall().post(`/Exam/AdminResetPasswordMainAsync`, data);
    },
    onSuccess: (data) => {
      set_notification({
        type: 'success',
        message: data?.data?.Message || 'Student Password Reset Successfully',
      });
      set_Nopen(true);
      queryClient.invalidateQueries(['reset-password']);
    },
    onError: (error: any) => {
      console.error('Error occurred:', error);
      set_notification({
        type: 'error',
        message: error?.response?.data?.Message || 'Error Occurred',
      });
      set_Nopen(true);
    },
    onSettled: (data, error) => {
      //console.log(data, error, 'settled');
      set_open(false);
    },
  });
  
  return (
    <Formik
      initialValues={{
        StudentNo: props.StudentNo || '',
        Password: props.Password || '',
      }}
      validationSchema={AddSchema}
      onSubmit={(values: any) => {
        const data = {
          StudentNo: values.StudentNo,
          Password: values.Password,
        };
        //console.log(data, 'form data');
        addUpdate(data);
      }}
    >
      {(formik: any) => {
        const { errors, values } = formik;
        return (
          <Form>
            <Flex flexDir={"column"} align={"center"} gap="20px">
              <Field
                as={Input}
                size="md"
                name="StudentNo"
                placeholder="Student No"
                type="text"
              />
              <Field
                as={Input}
                size="md"
                name="Password"
                placeholder="Set Password for student"
                type="text"
              />
              <Button disabled={isLoading} type="submit" bg="var(--dark-green-color)" color="var(--white-color)">
                {isLoading ? "Loading" : 'Submit'}
              </Button>
            </Flex>
          </Form>
        );
      }}
    </Formik>
  );
}  
const Label = styled.label``; 

const TempPopUp = (props:any) =>{
  const index = props.index;
  const data = props.data;
  // console.log(data,'data')
  const [active,set_active] = useAtom(SuspendAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom);
  const [,set_Nopen] = useAtom(openNAtom);
  const [,set_notification]= useAtom(notificationAtom);

  const handleClick = () =>{
    if(index === active){
      set_active(null);
      return;
    }
    else{
      set_active(index);
    }
  }
  const handleView= () =>{
    set_modal({
      header:'View Reseted student',
      content:<Grid>
        <GridItem justify="space-between" p="10px 0" as={Flex}>
          <span>Student No</span>
          <span>{data?.StudentNo || 'N/A'}</span>
        </GridItem >
        <GridItem justify="space-between" p="10px 0" as={Flex}>
          <span>First Name</span>
          <span>{data?.FirstName}</span>
        </GridItem >
        <GridItem justify="space-between" p="10px 0" as={Flex}>
          <span>LastName</span>
          <span>{data?.LastName}</span>
        </GridItem >
        <GridItem justify="space-between" p="10px 0" as={Flex}>
          <span>Email</span>
          <span>{data?.Email}</span>
        </GridItem >
        <GridItem as={Flex} justify="space-between" p="10px 0">
          <span>Reset Date</span>
          <span>{format(new Date(data?.LastModified), "dd/MM/yyyy")}</span>
        </GridItem>
      </Grid>
    })
    set_open(true);
    handleClick();
  }
  
  
  return (
    <TablePopUp click={handleClick} options={[
      {label:'View',click:handleView},
    ]} />
  )
}

